import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Headerdash from '../components/dashboard/layout/Headerdash';
import Sidebar from '../components/dashboard/layout/Sidebar';
import Footerdash from '../components/dashboard/layout/Footerdash';
import Dashboardhome from '../components/dashboard/Dashboardhome';
import Retailers from '../components/dashboard/Retailers';
import ChanageHomeContent from '../components/dashboard/ChanageHomeContent';
import Guests from '../components/dashboard/Guests';
import PayUTransaction from '../components/dashboard/PayUTransaction';
import RetailersTransactionReport from '../components/dashboard/RetailersTransactionReport';
import Notifications from '../components/dashboard/Notifications';
import AddressUpdate from '../components/dashboard/AddressUpdate';

import RiseTicket from '../components/dashboard/RiseTicket';
import OpenNewTicket from '../components/dashboard/OpenNewTicket';
import UserProfile from '../components/dashboard/UserProfile';
import Activities from '../components/dashboard/Activities';
import CloseTicket from '../components/dashboard/CloseTicket';

import NewPanApplication from '../components/dashboard/Forms/NewPanApplication';
import CorrectionPanApplication from '../components/dashboard/Forms/CorrectionPanApplication';
import NamePublication from '../components/dashboard/Forms/NamePublication';
import PANObject from '../components/dashboard/Forms/PANObject';
import PanFind from '../components/dashboard/Forms/PanFind';
import PanVerification from '../components/dashboard/Forms/PanVerification';
import CAMPRegistration from '../components/dashboard/Forms/CAMPRegistration';
import AddApplicants from '../components/dashboard/Forms/AddApplicants'; // your new page

import CAMPRegistrationReport from '../components/dashboard/Report/CAMPRegistrationReport';
import PublicationReport from '../components/dashboard/Report/NamePublicationReport';
import NewPanApplicationReport from '../components/dashboard/Report/NewPanApplicationReport';
import CorrectionPanApplicationReport from '../components/dashboard/Report/CorrectionPanApplicationReport';
import PANObjectReport from '../components/dashboard/Report/PANObjectReport';
import PanFindReport from '../components/dashboard/Report/PanFindReport';
import AddressUpdateReport from '../components/dashboard/Report/AddressUpdateReport';

import CAMPRegistrationCompleteReport from '../components/dashboard/AdminCompleteReport/CAMPRegistrationCompleteReport';
import NamePublicationCompleteReport from '../components/dashboard/AdminCompleteReport/NamePublicationCompleteReport';
import NewPanApplicationCompleteReport from '../components/dashboard/AdminCompleteReport/NewPanApplicationCompleteReport';
import CorrectionPanApplicationCompleteReport from '../components/dashboard/AdminCompleteReport/CorrectionPanApplicationCompleteReport';
import PANObjectCompleteReport from '../components/dashboard/AdminCompleteReport/PANObjectCompleteReport';
import PanFindCompleteReport from '../components/dashboard/AdminCompleteReport/PanFindCompleteReport';
import AddressUpdateCompleteReport from '../components/dashboard/AdminCompleteReport/AddressUpdateCompleteReport';

import NewPanApplicationAdminReport from '../components/dashboard/AdminReport/NewPanApplicationAdminReport';
import CorrectionPanApplicationAdminReport from '../components/dashboard/AdminReport/CorrectionPanApplicationAdminReport';
import NamePublicationAdminReport from '../components/dashboard/AdminReport/NamePublicationAdminReport';
import PANObjectAdminReport from '../components/dashboard/AdminReport/PANObjectAdminReport';
import CAMPRegistrationAdminReport from '../components/dashboard/AdminReport/CAMPRegistrationAdminReport';
import PanFindAdminReport from '../components/dashboard/AdminReport/PanFindReportAdmin';
import AddressUpdateAdminReport from '../components/dashboard/AdminReport/AddressUpdateAdminReport';

const Dashboard = () => {

  const [isMinified, setIsMinified] = useState(false);
  const [showPromoModal, setShowPromoModal] = useState(false);

  useEffect(() => {
    const promoShown = sessionStorage.getItem("promoShown");
    if (promoShown !== "true") {
      setShowPromoModal(true);
    }
  }, []);

  const handleClosePromo = () => {
    setShowPromoModal(false);
    sessionStorage.setItem("promoShown", "true");
  };

  const toggleSidebar = () => {
    setIsMinified(!isMinified);
  };

  return (
    <div className={`wrapper ${isMinified ? 'sidebar-minified' : ''}`}>
      <Sidebar isMinified={isMinified} />
      <div className="page-wrapper">
        <Headerdash toggleSidebar={toggleSidebar} />
        <div className="content-wrapper">
          <div className="content">
            <Routes>
              {/* Child routes of /dashboard */}
              <Route path="/" element={<Dashboardhome />} />
              <Route path="retailers" element={<Retailers />} />
              <Route path="guests" element={<Guests />} />
              <Route path="pay-u-transaction" element={<PayUTransaction />} />
              <Route path="retailor-transaction-report" element={<RetailersTransactionReport />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="address-update" element={<AddressUpdate />} />
              <Route path="rise-ticket" element={<RiseTicket />} />
              <Route path="open-new-ticket" element={<OpenNewTicket />} />
              <Route path="close-ticket" element={<CloseTicket />} />
              <Route path="user-profile" element={<UserProfile />} />
              <Route path="activities" element={<Activities />} />
              <Route path="*" element={<Dashboardhome />} />
              <Route path="chanage-home-content" element={<ChanageHomeContent />} />

              <Route path="new-pan-application" element={<NewPanApplication />} />
              <Route path="correction-pan-application" element={<CorrectionPanApplication />} />
              <Route path="name-publication" element={<NamePublication />} />
              <Route path="pan-object" element={<PANObject />} />
              <Route path="pan-find" element={<PanFind />} />
              <Route path="pan-verification" element={<PanVerification />} />
              <Route path="camp-registration" element={<CAMPRegistration />} />
              <Route path="/" element={<CAMPRegistration />} />
              <Route path="/add-applicants" element={<AddApplicants />} />

              <Route path="new-pan-application-report" element={<NewPanApplicationReport />} />
              <Route path="camp-registration-report" element={<CAMPRegistrationReport />} />
              <Route path="name-publication-report" element={<PublicationReport />} />
              <Route path="pan-object-report" element={<PANObjectReport />} />
              <Route path="pan-find-report" element={<PanFindReport />} />
              <Route path="correction-pan-application-report" element={<CorrectionPanApplicationReport />} />
              <Route path="new-address-report" element={<AddressUpdateReport />} />

              <Route path="new-pan-application-complete-report" element={<NewPanApplicationCompleteReport />} />
              <Route path="camp-registration-complete-report" element={<CAMPRegistrationCompleteReport />} />
              <Route path="name-publication-complete-report" element={<NamePublicationCompleteReport />} />
              <Route path="pan-object-complete-report" element={<PANObjectCompleteReport />} />
              <Route path="pan-find-complete-report" element={<PanFindCompleteReport />} />
              <Route path="correction-pan-application-complete-report" element={<CorrectionPanApplicationCompleteReport />} />
              <Route path="address-update-complete-report" element={<AddressUpdateCompleteReport />} />

              <Route path="camp-registration-admin-report" element={<CAMPRegistrationAdminReport />} />
              <Route path="correction-pan-application-admin-report" element={<CorrectionPanApplicationAdminReport />} />
              <Route path="name-publication-admin-report" element={<NamePublicationAdminReport />} />
              <Route path="new-pan-application-admin-report" element={<NewPanApplicationAdminReport />} />
              <Route path="pan-find-admin-report" element={<PanFindAdminReport />} />
              <Route path="pan-object-admin-report" element={<PANObjectAdminReport />} />
              <Route path="new-address-admin-report" element={<AddressUpdateAdminReport />} />

            </Routes>
          </div>
        </div>
        <Footerdash />
      </div>

      {showPromoModal && (
        <div className="modal-backdrop" style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
        }}>
          <div style={{
            background: "#fff", borderRadius: 16, width: "90%", maxWidth: 430, overflow: "hidden", 
            boxShadow: "0 15px 35px rgba(0,0,0,0.3)", fontFamily: "'Inter', sans-serif"
          }}>
            {/* Header with Purple Gradient */}
            <div style={{
              background: "linear-gradient(135deg, #9e6de0 0%, #8243d7 100%)",
              padding: "24px 20px", color: "#fff", textAlign: "center", position: "relative"
            }}>
              <h4 style={{ color: "#fff", margin: 0, fontWeight: "bold", fontSize: "1.4rem", letterSpacing: "0.5px" }}>
                🎉 Special Wallet Offer!
              </h4>
            </div>

            <div style={{ padding: "30px 24px", textAlign: "center" }}>
              <p style={{ color: "#455a64", fontSize: "1.05rem", lineHeight: "1.6", margin: "0 0 24px 0" }}>
                Supercharge your wallet balance today and get extra benefits!
              </p>

              {/* Offer Details Card */}
              <div style={{
                background: "#f3effc", border: "2px dashed #9e6de0", borderRadius: 12, 
                padding: "20px 15px", marginBottom: 28
              }}>
                <div style={{ fontSize: "1.1rem", color: "#6f42c1", fontWeight: "600", marginBottom: 6 }}>
                  Recharge with
                </div>
                <div style={{ fontSize: "2.2rem", color: "#9e6de0", fontWeight: "800", marginBottom: 6 }}>
                  ₹5,000
                </div>
                <div style={{ fontSize: "1.1rem", color: "#6f42c1", fontWeight: "600", marginBottom: 6 }}>
                  & Get
                </div>
                <div style={{ fontSize: "2.4rem", color: "#28a745", fontWeight: "800" }}>
                  ₹500 FREE!
                </div>
                <div style={{ fontSize: "0.9rem", color: "#6c757d", marginTop: 8, fontWeight: "500" }}>
                  (Instantly credited as ₹5,500 total)
                </div>
              </div>

              {/* Action Buttons */}
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <button 
                  className="btn btn-primary btn-block btn-pill" 
                  type="button" 
                  style={{ 
                    backgroundColor: "#9e6de0", borderColor: "#9e6de0", padding: "12px", 
                    fontSize: "1.05rem", fontWeight: "bold", boxShadow: "0 4px 12px rgba(158,109,224,0.3)" 
                  }} 
                  onClick={() => {
                    handleClosePromo();
                    window.dispatchEvent(new Event("triggerAddMoney"));
                  }}
                >
                  Recharge Now
                </button>
                <button 
                  className="btn btn-link" 
                  type="button" 
                  style={{ color: "#6c757d", textDecoration: "none", fontSize: "0.95rem", padding: "8px" }} 
                  onClick={handleClosePromo}
                >
                  Maybe Later
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Dashboard;
